export default (shutterStockEnabled = false) => {
  return shutterStockEnabled;
};
